export default __webpack_public_path__ + "static/media/akhal_teke.b77458bd.jpg";